import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { TendersList } from "@/pages/Tenders/TendersList";

export const TendersRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/tenders/all" replace />} />
            <Route path="/:mainTab" element={<TendersList />} />
            <Route path="/:mainTab/:subTab" element={<TendersList />} />
        </Routes>
    );
};

export { TendersList };
